import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "save",
  "use": "save-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"save\"><path d=\"M7 11.061l4.03-4.03A.75.75 0 109.969 5.97l-2.22 2.22V0h-1.5v8.189L4.03 5.97a.75.75 0 10-1.061 1.061L7 11.061zM0 12.5V14h14v-1.5H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol